import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import { PageSize } from "../../shared/constant";
import Endpoint from "../../shared/endpoints";
import contributorConstants from "../constants/contributorConstants";

const getContributors = (payload: any) =>
  api.get(
    `${
      payload?.labels?.length
        ? `${Endpoint.retrieveContributors}/labels/`
        : `${Endpoint.retrieveContributors}/`
    }`,
    {
      params: {
        ...(payload.clientId && { client: payload.clientId }),
        contributors_types__name: payload.type,
        page: payload.page,
        search: payload.searchText,
        ...(payload.labels &&
          payload.labels.length && { label__id: payload.labels?.join(", ") }),
        page_size: PageSize.FIFTY,
      },
    },
  );

const postContributor = (payload: any) => {
  return api.post(Endpoint.createContributor, payload);
};

const editContributor = (payload: any) => {
  return api.put(`${Endpoint.editContributor}/${payload.id}/`, payload.body);
};

const deleteContributor = (payload: any) => {
  return api.delete(`${Endpoint.deleteContributor}/${payload.id}/`);
};

const getType = (type: string) => {
  // console.log(type);
  if (type === "ARTIST") return contributorConstants.GET_ARTISTS_LIST_SUCCESS;
  if (type === "COMPOSER")
    return contributorConstants.GET_COMPOSERS_LIST_SUCCESS;
  if (type === "LYRICIST")
    return contributorConstants.GET_LYRICISTS_LIST_SUCCESS;
  return contributorConstants.GET_CONTRIBUTORS_LIST_SUCCESS;
};

const getFailureType = (type: string) => {
  if (type === "ARTIST") return contributorConstants.GET_ARTISTS_LIST_FAILURE;
  if (type === "COMPOSER")
    return contributorConstants.GET_COMPOSERS_LIST_FAILURE;
  if (type === "LYRICIST")
    return contributorConstants.GET_LYRICISTS_LIST_FAILURE;

  return contributorConstants.GET_CONTRIBUTORS_LIST_FAILURE;
};

function* retrieveContributors(action: any) {
  try {
    const response: AxiosResponse = yield call(getContributors, action.payload);
    yield put({
      type: getType(action.payload.type),
      payload: response,
    });
  } catch (e) {
    yield put({ type: getFailureType(action.payload.type), err: e });
  }
}

function* addContributor(action: any) {
  try {
    const response: AxiosResponse = yield call(postContributor, action.payload);
    yield put({
      type: contributorConstants.ADD_CONTRIBUTOR_REQ_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: contributorConstants.ADD_CONTRIBUTOR_REQ_FAILURE,
      err: e,
    });
  }
}

function* editContributorAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(editContributor, action.payload);
    yield put({
      type: contributorConstants.EDIT_CONTRIBUTOR_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: contributorConstants.EDIT_CONTRIBUTOR_FAILURE,
      err: e,
    });
  }
}

function* deleteContributorAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      deleteContributor,
      action.payload,
    );
    yield put({
      type: contributorConstants.DELETE_CONTRIBUTOR_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: contributorConstants.DELETE_CONTRIBUTOR_FAILURE,
      err: e,
    });
  }
}

function* contributorSaga() {
  yield all([
    takeEvery(contributorConstants.GET_CONTRIBUTORS_LIST, retrieveContributors),
  ]);
  yield all([
    takeEvery(contributorConstants.ADD_CONTRIBUTOR_REQ, addContributor),
  ]);
  yield all([
    takeEvery(
      contributorConstants.EDIT_CONTRIBUTOR_REQUEST,
      editContributorAsync,
    ),
  ]);
  yield all([
    takeEvery(
      contributorConstants.DELETE_CONTRIBUTOR_REQUEST,
      deleteContributorAsync,
    ),
  ]);
}

export default contributorSaga;
